import { render, staticRenderFns } from "./logisticsReceiptList.vue?vue&type=template&id=070f1f5a"
import script from "./logisticsReceiptList.vue?vue&type=script&lang=js"
export * from "./logisticsReceiptList.vue?vue&type=script&lang=js"
import style0 from "./logisticsReceiptList.vue?vue&type=style&index=0&id=070f1f5a&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports